<template>
  <section class="bg-message-image">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 relative font-message ">
      <div class="relative">
        <!-- Section header -->
        <div class="max-w-xl mx-auto text-center pt-16 pb-12 md:pb-16">
          <p class="h4 font-normal text-theme-900 mt-12" data-aos="fade-up">
            私、高橋とマンツーマンでセッションをすることができます。<br />グループレッスンとは違い、あなたの悩みに対してピンポイントの指導を受けることができます。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "DescriptionPersonal",
  components: {},
  data: function() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.bg-message-image {
  background-image: url("./../images/message-background.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  .font-message {
    .h4 {
      line-height: 1.6;
    }
  }
}
</style>
